import React from 'react';
import { TwTheme } from '../../Tw';
import { getBestContrastColor } from '../common/color.helper';
import { ABC_COLORS } from '../simulation/sku-profiling';

interface TagVelocityCategoryProps {
  rank: string;
  className?: string;
}

const complianceColors = TwTheme.extend.colors.compliance;

export const TagVelocityCategory: React.FC<TagVelocityCategoryProps> = ({
  rank,
  className = '',
}) => {
  // Determine if this is a compliance status
  const isCompliance = rank === 'Compliant' || rank === 'Non-Compliant';

  // Get the appropriate background color
  const getBackgroundColor = () => {
    if (isCompliance) {
      return rank === 'Compliant'
        ? complianceColors.compliant
        : complianceColors.nonCompliant;
    }
    return ABC_COLORS[rank] || ABC_COLORS.Unknown;
  };

  const backgroundColor = getBackgroundColor();

  return (
    <span
      className={`rounded px-2 py-1 ${className}`}
      style={{
        backgroundColor,
        color: getBestContrastColor(backgroundColor),
      }}
    >
      {rank}
    </span>
  );
};

export default TagVelocityCategory;
